import { render } from "./SelectDetails.vue?vue&type=template&id=5c1e2133&scoped=true"
import script from "./SelectDetails.vue?vue&type=script&lang=js"
export * from "./SelectDetails.vue?vue&type=script&lang=js"

import "./SelectDetails.vue?vue&type=style&index=0&id=5c1e2133&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1e2133"]])

export default __exports__